
import React, { useState, useEffect } from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { BorrowingsTabs } from '@/components/borrowings/BorrowingsTabs';
import { AddLoanDialog } from '@/components/borrowings/debt/AddLoanDialog';
import { Skeleton } from "@/components/ui/skeleton";

const Borrowings = () => {
  const [showAddLoanDialog, setShowAddLoanDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Simulate faster initial load
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 50); // Reduced from 100ms to 50ms for more responsive feel
    return () => clearTimeout(timer);
  }, []);

  const handleAddLoan = () => {
    // This will be handled inside the AddLoanDialog
    setShowAddLoanDialog(false);
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Treasury Borrowings</h1>
        <p className="text-muted-foreground">
          Manage bank borrowings, repayments, and financial covenants.
        </p>
      </div>
      
      {isLoading ? (
        <div className="animate-pulse">
          <Skeleton className="h-12 w-full mb-4" />
          <Skeleton className="h-64 w-full" />
        </div>
      ) : (
        <Card>
          <CardContent className="p-0">
            <BorrowingsTabs 
              showAddLoanDialog={showAddLoanDialog}
              setShowAddLoanDialog={setShowAddLoanDialog}
              isLoading={isLoading}
            />
          </CardContent>
        </Card>
      )}
      
      {!isLoading && (
        <AddLoanDialog 
          open={showAddLoanDialog} 
          setOpen={setShowAddLoanDialog} 
          handleAddLoan={handleAddLoan} 
        />
      )}
    </div>
  );
};

export default Borrowings;
